import React, { useState } from "react";
import {
	Card,
	CardContent,
	Typography,
	Box,
	Button,
	List,
	ListItem,
	ListItemText,
	ListItemSecondaryAction,
	IconButton,
	TextField,
	Grid,
	Chip,
} from "@material-ui/core";
import {
	Plus as AddIcon,
	Trash2 as DeleteIcon,
} from "react-feather";

interface CategorizedItem {
	id: string;
	text: string;
	category: 'areas' | 'instruments';
}

export const InspectionScopeTab = () => {
	const [areas, setAreas] = useState<CategorizedItem[]>([]);
	const [instruments, setInstruments] = useState<CategorizedItem[]>([]);
	const [newAreaText, setNewAreaText] = useState("");
	const [newInstrumentText, setNewInstrumentText] = useState("");

	const addArea = () => {
		if (newAreaText.trim()) {
			const newArea: CategorizedItem = {
				id: Date.now().toString(),
				text: newAreaText.trim(),
				category: 'areas',
			};
			setAreas([...areas, newArea]);
			setNewAreaText("");
		}
	};

	const addInstrument = () => {
		if (newInstrumentText.trim()) {
			const newInstrument: CategorizedItem = {
				id: Date.now().toString(),
				text: newInstrumentText.trim(),
				category: 'instruments',
			};
			setInstruments([...instruments, newInstrument]);
			setNewInstrumentText("");
		}
	};

	const deleteArea = (id: string) => {
		setAreas(areas.filter(area => area.id !== id));
	};

	const deleteInstrument = (id: string) => {
		setInstruments(instruments.filter(instrument => instrument.id !== id));
	};

	return (
		<Card>
			<CardContent>
				<Typography variant="h6" gutterBottom>
					Alcances de la Inspección
				</Typography>
				
				<Grid container spacing={3}>
					{/* Areas Section */}
					<Grid item xs={12} md={6}>
						<Box>
							<Typography variant="subtitle1" gutterBottom>
								<Chip label="Áreas" color="primary" size="small" style={{ marginRight: 8 }} />
								Áreas de Inspección
							</Typography>
							
							<Grid container spacing={1} alignItems="center" style={{ marginBottom: 16 }}>
								<Grid item xs={8}>
									<TextField
										fullWidth
										variant="outlined"
										size="small"
										placeholder="Nueva área..."
										value={newAreaText}
										onChange={(e) => setNewAreaText(e.target.value)}
										onKeyPress={(e) => {
											if (e.key === 'Enter') {
												addArea();
											}
										}}
									/>
								</Grid>
								<Grid item xs={4}>
									<Button
										variant="contained"
										color="primary"
										startIcon={<AddIcon />}
										onClick={addArea}
										fullWidth
										size="small"
										disabled={!newAreaText.trim()}
									>
										Agregar
									</Button>
								</Grid>
							</Grid>

							<List dense>
								{areas.map((area, index) => (
									<ListItem key={area.id} divider={index < areas.length - 1}>
										<ListItemText 
											primary={area.text}
											primaryTypographyProps={{ variant: 'body2' }}
										/>
										<ListItemSecondaryAction>
											<IconButton
												edge="end"
												onClick={() => deleteArea(area.id)}
												color="secondary"
												size="small"
											>
												<DeleteIcon fontSize="small" />
											</IconButton>
										</ListItemSecondaryAction>
									</ListItem>
								))}
							</List>

							{areas.length === 0 && (
								<Typography variant="body2" color="textSecondary" style={{ textAlign: 'center', padding: 16 }}>
									No hay áreas agregadas
								</Typography>
							)}
						</Box>
					</Grid>

					{/* Instruments Section */}
					<Grid item xs={12} md={6}>
						<Box>
							<Typography variant="subtitle1" gutterBottom>
								<Chip label="Instrumentos" color="secondary" size="small" style={{ marginRight: 8 }} />
								Instrumentos de Inspección
							</Typography>
							
							<Grid container spacing={1} alignItems="center" style={{ marginBottom: 16 }}>
								<Grid item xs={8}>
									<TextField
										fullWidth
										variant="outlined"
										size="small"
										placeholder="Nuevo instrumento..."
										value={newInstrumentText}
										onChange={(e) => setNewInstrumentText(e.target.value)}
										onKeyPress={(e) => {
											if (e.key === 'Enter') {
												addInstrument();
											}
										}}
									/>
								</Grid>
								<Grid item xs={4}>
									<Button
										variant="contained"
										color="secondary"
										startIcon={<AddIcon />}
										onClick={addInstrument}
										fullWidth
										size="small"
										disabled={!newInstrumentText.trim()}
									>
										Agregar
									</Button>
								</Grid>
							</Grid>

							<List dense>
								{instruments.map((instrument, index) => (
									<ListItem key={instrument.id} divider={index < instruments.length - 1}>
										<ListItemText 
											primary={instrument.text}
											primaryTypographyProps={{ variant: 'body2' }}
										/>
										<ListItemSecondaryAction>
											<IconButton
												edge="end"
												onClick={() => deleteInstrument(instrument.id)}
												color="secondary"
												size="small"
											>
												<DeleteIcon fontSize="small" />
											</IconButton>
										</ListItemSecondaryAction>
									</ListItem>
								))}
							</List>

							{instruments.length === 0 && (
								<Typography variant="body2" color="textSecondary" style={{ textAlign: 'center', padding: 16 }}>
									No hay instrumentos agregados
								</Typography>
							)}
						</Box>
					</Grid>
				</Grid>
			</CardContent>
		</Card>
	);
};